import api from "./api";

async function getBankAccountTransactions() {
  try {
    var response = await api.get(
      "api/bankaccounttransactions"
    );
    return response.data;;
  } catch (error) {
    return false;
  }
}

export {
  getBankAccountTransactions
}